import {Component, ElementRef, Injector, OnInit, Renderer2, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../../services/user.service';
import {AppConfig} from '../../app.config';
import {SnackBarService} from '../../services/snack-bar.service';
import {PomodoroRepository} from '../../Models/PomodoroRepository';

@Component({
  selector: 'app-forget-pass',
  templateUrl: './forget-pass.component.html',
  styleUrls: ['./forget-pass.component.css']
})
export class ForgetPassComponent implements OnInit {
  @ViewChild('test') test: ElementRef;
  public user = {
    mobile: ''
  };
  public pomodoroRepository: PomodoroRepository;
  public error: any;
  public registerSpinner = false;
  constructor(private router: Router,
              private userService: UserService,
              private config: AppConfig,
              private snackbarService: SnackBarService,
              private renderer: Renderer2,
              private injector: Injector) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
  }
  redirectToVerify(): any{
    this.router.navigateByUrl('verify').then();
  }
  loginUser(): any{
    this.registerSpinner = true;
    this.renderer.setStyle(this.test.nativeElement, 'width', '145px');
    if (!this.user.mobile){
      if (localStorage.getItem('trans') === 'fa') {
        this.snackbarService.showSnackBar('پر کردن فیلد الزامی است.', 'red-snackbar');
      } else {
        this.snackbarService.showSnackBar('Field is required', 'red-snackbar');
      }
      this.registerSpinner = false;
      return;
    }else{
      localStorage.setItem('mobile', this.user.mobile);
      this.userService.sendVerificationCode(this.user).subscribe(
        () => {
          if (localStorage.getItem('trans') === 'fa'){
            // tslint:disable-next-line:max-line-length
            this.snackbarService.showSnackBar( 'کد عبور برای شما ارسال شد.. لطفا تا زمان دریافت کد چند لحظه منتظر بمانید', 'green-snackbar');
          } else{
            this.snackbarService.showSnackBar( 'A password has been sent to you. Please wait a moment until you receive the code.', 'green-snackbar');
          }
          this.registerSpinner = false;
          this.renderer.setStyle(this.test.nativeElement, 'width', '120px');
          this.redirectToVerify();
        }, (err) => {
          this.error = JSON.parse(err.error);
          if (this.pomodoroRepository.ltrDirection === true){
            // tslint:disable-next-line:forin
            for (const i in this.error) {
              const child = this.error[i];
              this.snackbarService.showSnackBar( child[0], 'ltr-snackbar');
              break;
            }
          }
          if (this.pomodoroRepository.ltrDirection === false){
            // tslint:disable-next-line:forin
            for (const i in this.error) {
              const child = this.error[i];
              this.snackbarService.showSnackBar( child[0], 'red-snackbar');
              break;
            }
          }
          this.registerSpinner = false;
          this.renderer.setStyle(this.test.nativeElement, 'width', '120px');
        });
    }
  }
  testRenderer(): any{
    this.renderer.setStyle(this.test.nativeElement, 'width', '145px');
  }
}
